import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const apiClient = axios.create({
    baseURL: API,
    headers: { "Content-Type": "application/json" },
});

/** Resolve a stored photo URL into a full src for an <img> tag. */
export function resolvePhotoUrl(url) {
    if (!url) return "";
    if (url.startsWith("http://") || url.startsWith("https://")) return url;
    if (url.startsWith("/api/")) return `${BACKEND_URL}${url}`;
    return url; // frontend-static path like "/photos/hh-01.jpg"
}

export async function submitContact(payload) {
    const res = await apiClient.post("/contact", payload);
    return res.data;
}

export async function listProjectPhotos() {
    const res = await apiClient.get("/projects/photos");
    return res.data;
}

function adminHeaders(token) {
    return { "X-Admin-Token": token };
}

export async function verifyAdmin(token) {
    const res = await apiClient.post("/admin/verify", null, { headers: adminHeaders(token) });
    return res.data;
}

export async function uploadProjectPhoto({ token, file, caption }) {
    const fd = new FormData();
    fd.append("file", file);
    if (caption) fd.append("caption", caption);
    const res = await axios.post(`${API}/admin/photos`, fd, {
        headers: { ...adminHeaders(token), "Content-Type": "multipart/form-data" },
    });
    return res.data;
}

export async function deleteProjectPhoto({ token, id }) {
    const res = await apiClient.delete(`/admin/photos/${id}`, { headers: adminHeaders(token) });
    return res.data;
}

export async function listSubmissions(token) {
    const res = await apiClient.get("/admin/submissions", { headers: adminHeaders(token) });
    return res.data;
}

/** Fetch the submissions CSV with the admin header and trigger a browser download. */
export async function downloadSubmissionsCsv(token) {
    const res = await axios.get(`${API}/admin/submissions.csv`, {
        headers: adminHeaders(token),
        responseType: "blob",
    });
    const blobUrl = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = blobUrl;
    a.download = "harris-homes-inquiries.csv";
    document.body.appendChild(a);
    a.click();
    a.remove();
    URL.revokeObjectURL(blobUrl);
}
